import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'input[app-input], textarea[app-input]',
  template: '',
  styleUrls: ['./input.component.scss'],
  standalone: true,
})
export class InputComponent {
  @HostBinding('class.app-input') readonly isInput = true;
}
